function bindFilterButtons() {
  document.querySelectorAll('#filtersDrawerBtn, #filtersDrawerBtnMobile').forEach(btn => {
    if (btn._filtersBound) return;
    btn._filtersBound = true;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openFiltersDrawer();
    }, true);
  });
}

function openFiltersDrawer() {
  const drawer = document.getElementById('filtersDrawer');
  const overlay = document.getElementById('filtersOverlay');
  if (!drawer) return;

  const header =
    document.querySelector('.header-wrapper') ||
    document.querySelector('.site-header') ||
    document.querySelector('sticky-header') ||
    document.querySelector('#shopify-section-header') ||
    document.querySelector('header');
  const h = header ? Math.round(header.getBoundingClientRect().bottom) : 0;

  if (window.innerWidth <= 768) {
    drawer.style.top = h + 'px';
    drawer.style.height = 'calc(100dvh - ' + h + 'px)';
    if (overlay) {
      overlay.style.top = h + 'px';
      overlay.style.height = 'calc(100dvh - ' + h + 'px)';
    }
  } else {
    drawer.style.top = h + 'px';
    drawer.style.height = 'calc(100vh - ' + h + 'px)';
    if (overlay) {
      overlay.style.top = h + 'px';
      overlay.style.height = 'calc(100vh - ' + h + 'px)';
    }
  }

  drawer.classList.add('active');
  if (overlay) overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  const params = new URLSearchParams(window.location.search);
  drawer.querySelectorAll('input[type="checkbox"]').forEach(cb => {
    cb.checked = params.getAll(cb.name).includes(cb.value);
  });
  updateCountGlobal();
}

function updateCountGlobal() {
  const params = new URLSearchParams(window.location.search);
  const filterKeys = [
    'filter.p.m.global.energie-totale-du-plat-kcal',
    'filter.p.m.custom.portion',
    'filter.p.m.custom.duree_preparation',
    'filter.p.m.custom.rehydratation',
    'filter.p.m.custom.type_de_plats',
    'filter.p.m.custom.regime_alimentaire',
    'filter.p.m.custom.fonction'
  ];
  let count = 0;
  filterKeys.forEach(k => { count += params.getAll(k).length; });
  document.querySelectorAll('#filtersCount, #filtersCountMobile').forEach(badge => {
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'inline-flex';
    } else {
      badge.style.display = 'none';
    }
  });
}

function closeDrawer() {
  const drawer = document.getElementById('filtersDrawer');
  const overlay = document.getElementById('filtersOverlay');
  if (drawer) drawer.classList.remove('active');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
}

function applyFilters() {
  const drawer = document.getElementById('filtersDrawer');
  const params = new URLSearchParams(window.location.search);
  ['filter.p.m.global.energie-totale-du-plat-kcal','filter.p.m.custom.portion','filter.p.m.custom.duree_preparation','filter.p.m.custom.rehydratation','filter.p.m.custom.type_de_plats','filter.p.m.custom.regime_alimentaire','filter.p.m.custom.fonction'].forEach(k => params.delete(k));
  drawer.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
    params.append(cb.name, cb.value);
  });
  window.location.search = params.toString();
}

function initFilters() {
  const drawer = document.getElementById('filtersDrawer');
  if (!drawer) return;

  updateCountGlobal();
  bindFilterButtons();

  // Délégation sur document — résiste aux rechargements AJAX
  document.addEventListener('click', function(e) {
    if (e.target.closest('#filtersDrawerClose') || e.target.closest('#filtersOverlay')) {
      closeDrawer();
    }
    if (e.target.closest('#filtersApply')) {
      applyFilters();
    }
    if (e.target.closest('#filtersReset')) {
      document.querySelectorAll('#filtersDrawer input[type="checkbox"]').forEach(cb => cb.checked = false);
      updateCountGlobal();
      const url = new URL(window.location.href);
      url.search = '';
      window.location.href = url.toString();
    }
  });

  document.querySelectorAll('#filtersDrawer input[type="checkbox"]').forEach(cb => {
    cb.onchange = updateCountGlobal;
  });

  const initParams = new URLSearchParams(window.location.search);
  document.querySelectorAll('#filtersDrawer input[type="checkbox"]').forEach(cb => {
    if (initParams.getAll(cb.name).includes(cb.value)) cb.checked = true;
  });
}

// MutationObserver avec debounce
let _bindDebounce;
new MutationObserver(() => {
  clearTimeout(_bindDebounce);
  _bindDebounce = setTimeout(bindFilterButtons, 100);
}).observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFilters);
} else {
  initFilters();
}
